import { Auth } from "aws-amplify";

class SecureTokenManager {
  constructor() {
    this.tokenCache = new Map();
    this.TOKEN_REFRESH_THRESHOLD = 5 * 60 * 1000; // 5 minutes before expiry
  }

  async getValidToken() {
    try {
      const session = await Auth.currentSession();
      const idToken = session.getIdToken();
      const jwtToken = idToken.getJwtToken();
      
      // Check if token is close to expiry
      const payload = idToken.payload;
      const currentTime = Math.floor(Date.now() / 1000);
      const timeUntilExpiry = payload.exp - currentTime;
      
      if (timeUntilExpiry < this.TOKEN_REFRESH_THRESHOLD / 1000) {
        // console.log('Token close to expiry, refreshing...');
        await Auth.currentSession(); // This will refresh if needed
        return this.getValidToken(); // Recursive call to get fresh token
      }
      
      return jwtToken;
    } catch (error) {
      // console.error('Error getting valid token:', error);
      throw new Error('Failed to get valid authentication token');
    }
  }

  async makeAuthenticatedRequest(apiCall) {
    try {
      const token = await this.getValidToken();
      return await apiCall(token);
    } catch (error) {
      // console.error('Authenticated request failed:', error);
      throw error;
    }
  }

  // Validate token structure (basic client-side check)
  isTokenStructureValid(token) {
    if (!token || typeof token !== 'string') return false;
    
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    
    try {
      // Just check if we can decode the header and payload
      JSON.parse(atob(parts[0]));
      JSON.parse(atob(parts[1]));
      return true;
    } catch {
      return false;
    }
  }
}

export const tokenManager = new SecureTokenManager();